import { render, staticRenderFns } from "./tabInsure.vue?vue&type=template&id=0337fe69&"
import script from "./tabInsure.vue?vue&type=script&lang=js&"
export * from "./tabInsure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0337fe69')) {
      api.createRecord('0337fe69', component.options)
    } else {
      api.reload('0337fe69', component.options)
    }
    module.hot.accept("./tabInsure.vue?vue&type=template&id=0337fe69&", function () {
      api.rerender('0337fe69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabInsure.vue"
export default component.exports